module.exports = __webpack_public_path__ + "img/a3-s69.974ea25c.jpg";